import { useState } from 'react';
import { Chip, Stack } from '@mui/material';
import { KnowledgeAreasEditDialog } from './knowledge-areas-edit-dialog';
import { useRecommendationProfile } from '@/context/recommendation-profile';
import type { KnowledgeArea } from '@/models/bootstrap/taxonomy';
import { ProfileItem } from '@/packages/my-profile/components/profile-item';

export const KnowledgeAreas = () => {
  const { profile, updateProfile } = useRecommendationProfile();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleSave = (knowledgeAreas: KnowledgeArea[]) => {
    updateProfile({
      profile: {
        ...profile,
        knowledge_areas: knowledgeAreas,
      },
    });
    setIsDialogOpen(false);
  };

  const hasKnowledgeAreas =
    profile?.knowledge_areas && profile?.knowledge_areas?.length > 0;

  return (
    <>
      <ProfileItem title="Temas" onClick={() => setIsDialogOpen(true)}>
        {hasKnowledgeAreas && (
          <Stack direction="row" gap={2} flexWrap="wrap">
            {profile?.knowledge_areas?.map((knowledgeArea: KnowledgeArea) => (
              <Chip
                key={knowledgeArea.id}
                label={knowledgeArea.description_pt_br}
              />
            ))}
          </Stack>
        )}
      </ProfileItem>
      {isDialogOpen && (
        <KnowledgeAreasEditDialog
          currentValues={profile?.knowledge_areas ?? []}
          onClose={() => setIsDialogOpen(false)}
          onSave={handleSave}
        />
      )}
    </>
  );
};
